/**
 * @name generic-bots.constants
 * @description Core generic-bots.constants in ngx-responsive
 *
 * @license MIT
 */
import { IBot } from '../interfaces';

export const BOTS: IBot = {
    GENERIC_BOT: 'Generic Bot'
};
